// 跳脫放進 SVG／XML 的使用者文字。
export function escapeXml(value: string): string {
  return value.replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' })[char]!);
}

// 從 Sind 輸出的 SVG 取回內嵌的大綱原文；沒有則回傳 null。
export function extractSource(svg: string): string | null {
  const match = /<sind:source[^>]*>([\s\S]*?)<\/sind:source>/.exec(svg);
  if (!match) return null;
  return match[1]!.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, '$1');
}
